import styled from "styled-components";

import { FlexWrapper } from "./services/style";

export const PageTitileContainer = styled(FlexWrapper)`
  margin-bottom: 16px;
  align-items: center;
`;

export const ProfilingHeader = styled.h1`
  font-weight: 700;
  font-size: 20px;
  margin: 0;
`;
